import { useState } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import Rules from "./rules";

const OnbButton = ({ loading = false, onClick }) => {
  const { t } = useTranslation();
  const [checked, setChecked] = useState(false);

  return (
    <div className="p-5 fixed bottom-0  border-t bg-white sm:bg-transparent border-gray--7 max-w-2xl  w-full  sm:border-none">
      <Rules
        onChangeRules={(visible) => {
          setChecked(visible.target.checked);
        }}
      />
      <Button
        block
        className={`${
          !checked ? "disabled-button-large" : "primary-button-large"
        } justify-center  min-h-[46px] items-center `}
        disabled={!checked || loading}
        loading={loading}
        onClick={onClick}
      >
        {t("pma-onboarding.signed-contract")}
      </Button>
    </div>
  );
};
export default OnbButton;
